import {
  AIOSYN_APP_URL,
  AIRA_APP_URL,
  QC_APP_URL,
  TISSUE_SEGMENTATION_APP_URL,
} from 'components/AITools/constants/common';
import hw_logo from 'images/icons/hw.png';
import aiosyn_logo from 'images/icons/aiosyn-no-bg.png';
import aira_logo from 'images/icons/aira.png';

export const ALL_TAB = 'all';
export const COMPLETED_TAB = 'completed';
export const IN_PROGRESS_TAB = 'in_progress';

export const AI_COMPUTE_TRANSACTIONS_TABS_LIST = [
  {
    value: ALL_TAB,
    label: 'all',
  },
  {
    value: COMPLETED_TAB,
    label: 'completed',
  },
  {
    value: IN_PROGRESS_TAB,
    label: 'in progress',
  },
];

export const REQUESTED_LOG_STATUS = 'requested';
export const PROCESSING_LOG_STATUS = 'processing';
export const RESPONSE_FAILED_LOG_STATUS = 'response_failed';
export const REQUEST_FAILED_LOG_STATUS = 'request_failed';
export const COMPLETED_LOG_STATUS = 'completed';
export const PARTLY_COMPLETED_LOG_STATUS = 'partly_completed';

export const TISSUE_SEGMENTATION_ML_TYPE = 'tissue_segmentation';
export const HISTOMORPHO_ML_TYPE = 'histomorpho';
export const QUALITY_CONTROL_ML_TYPE = 'quality_control';
export const AIOSYN_KIDNEY_ML_TYPE = 'aiosyn_kidney';
export const AIRA_LIVER_ML_TYPE = 'aira_liver';

export const NO_FILTER_VALUE = 'no_filter';

export const EMPTY_SELECT_OPTION = {
  short: 'No filter',
  value: NO_FILTER_VALUE,
};

export const TOOL_TYPE_NAMES = {
  [QUALITY_CONTROL_ML_TYPE]: {
    short: 'Image Quality',
    long: 'HistoWiz AutoQC Tool',
    app_url: QC_APP_URL,
    logo: hw_logo,
  },
  [TISSUE_SEGMENTATION_ML_TYPE]: {
    short: 'Tissue Segmentation',
    long: 'HistoWiz Tissue Segmentation Tool',
    app_url: TISSUE_SEGMENTATION_APP_URL,
    logo: hw_logo,
  },
  [AIOSYN_KIDNEY_ML_TYPE]: {
    short: 'Kidney Analysis',
    long: 'Aiosyn Pre-Clinical Kidney Analysis Model',
    app_url: AIOSYN_APP_URL,
    logo: aiosyn_logo,
  },
  [AIRA_LIVER_ML_TYPE]: {
    short: 'Liver Analysis',
    long: 'AIRA Matrix Liver Analysis',
    app_url: AIRA_APP_URL,
    logo: aira_logo,
  },
};

export const IN_PROGRESS_STATUSES = [
  REQUESTED_LOG_STATUS,
  PROCESSING_LOG_STATUS,
];

export const COMPLETED_STATUSES = [
  COMPLETED_LOG_STATUS,
  PARTLY_COMPLETED_LOG_STATUS,
];

export const FAILED_STATUSES = [
  RESPONSE_FAILED_LOG_STATUS,
  REQUEST_FAILED_LOG_STATUS,
];

export const ALL_STATUSES = [
  IN_PROGRESS_STATUSES,
  COMPLETED_STATUSES,
  FAILED_STATUSES,
];
